import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["retainHeight", "children"];
import React, { useRef, useEffect } from 'react';
import { ResultRenderWrapper } from '@atlassian/search-dialog';
export var HeightRetainingContainer = function HeightRetainingContainer(_ref) {
  var retainHeight = _ref.retainHeight,
    children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  var minimumHeight = useRef(undefined);
  var ref = useRef(null);

  // Why is this not in a `useEffect`?
  // Render order for React is from top down (parent -> children), this enables to retain the most up to date height of the children before a transition happens.
  // useEffect happens after render so we won't be able to account for changes to child height that does not cause a render to this component, checking the height
  // when the transition happens would be too late as it will register the new height instead.
  if (retainHeight) {
    var _ref$current;
    var height = (_ref$current = ref.current) === null || _ref$current === void 0 || (_ref$current = _ref$current.getBoundingClientRect()) === null || _ref$current === void 0 ? void 0 : _ref$current.height;
    minimumHeight.current = height;
  }

  // Despite what is said above we do need to track the initial size, this can only be done once the ref.current? is set hence the onMount useEffect here.
  useEffect(function () {
    var _ref$current2;
    var height = (_ref$current2 = ref.current) === null || _ref$current2 === void 0 || (_ref$current2 = _ref$current2.getBoundingClientRect()) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.height;
    minimumHeight.current = height;
  }, []);
  var shouldFixMinimumHeight = retainHeight && minimumHeight.current;
  return /*#__PURE__*/React.createElement(ResultRenderWrapper, _extends({
    shouldFixMinimumHeight: shouldFixMinimumHeight,
    minimumHeight: minimumHeight.current,
    ref: ref
  }, rest), children);
};